import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {websiteUserCommentList_template} from "../components/templates/websiteUserCommentList_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class website_users_comments extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: websiteUserCommentList_template;
    protected pagination: pagination_template;
    protected loaderActive: boolean = false;
    protected timer;
    protected exportCSVxhr : XMLHttpRequest

    protected getModuleName(){

        return "website_users_comments";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        // create the users list
        this.elementsList = new websiteUserCommentList_template("list", this.viewModel, this);
        this.template = this.elementsList;

        //only show Add User button if CM or Admin
        let vnApp = this.getVnAppZone().app;
        let roles = vnApp.loggedUser.user.valnet_user.roles;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Website Users Comments List");

        return [this.elementsList.build()];
    }


    fillPage() : void{

        this.getReferences();
        this.elementsList.buildDatePickerCalendar();
    }

    protected editComment(){

        this.loadingIn(this.elementsList.builtTemplate);

        let formReq_url: string = '/api/website-users/comments/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = this.elementsList.getViewModelForSave();
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {
                obj.manageResponse(req, obj, function () {
                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Comment saved!");
                        obj.getVnAppZone().showNotificationToModule();
                        obj.elementsList.onClickHidePopUp();
                        obj.filterList();
                    }
                });
                obj.loadingOut(obj.elementsList.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected commentListReorder(){

        this.filterList();
    }

    protected onShowActiveUsers() {

        this.filterList();
    }

    protected filterDropdownOnChange(idElement = null){

        if (idElement != 'updateStatuses') {
            if (idElement == 'brandFilter') {
                this.elementsList.handleBrandColumnDisplay();
            }

            if (idElement == 'commentsPerPageFilter') {
                this.elementsList.setSelectAllChecked(false);
            }

            this.viewModel.list.pagination.pageNumber(1);
            this.filterList();
        }
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDateOnChange(){

        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected setDefaultStatusFilters(){

        this.elementsList.setDefaults();
    }

    protected filterByUrl(){

        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterByPresets(filters){

        this.elementsList.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected getMemoryViewModel(){

        let templateViewModel = this.elementsList.getTemplateViewModel();
        delete templateViewModel.user;
        return templateViewModel;
    }

    protected getReferences() {

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate);

        let usrReq_url: string = '/api/website-users/comments/references';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesRequestReturn;
        this.XHRHdl.execute();
    }

    public onReferencesRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                obj.loadingOut(obj.elementsList.builtTemplate);

                let responseParsed = JSON.parse(req.request.response);
                obj.elementsList.setBrands(responseParsed.brands);
                obj.elementsList.setStatuses(responseParsed.statuses);
                obj.elementsList.setIsPinnedOptions(responseParsed.isPinnedOptions);
                obj.elementsList.setIsReplyOptions(responseParsed.isReplyOptions);
                obj.elementsList.setIsEmakiUsersOptions(responseParsed.isEmakiUserOptions);
                obj.elementsList.setIsEditedOptions(responseParsed.isEditedOptions);
                obj.elementsList.setIsManuallyModeratedOptions(responseParsed.isManuallyModeratedOptions);
                obj.elementsList.setContainsImagesOptions(responseParsed.containsImagesOptions);
                obj.elementsList.setImageStatuses(responseParsed.imageStatuses);
                obj.elementsList.setUpdateStatuses(responseParsed.updateStatuses);

                //set filters
                obj.updateViewModelFromPath();
                obj.getSearchPresetsListData();
                obj.elementsList.handleBrandColumnDisplay();
            })
        }
    }

    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.elementsList.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    public uploadImage(data, event){

        let image = event.target.files;
        if(image.length == 1){

            let formReq_url: string = '/api/website-users/comments/image/upload/';

            var formData = new FormData();
            formData.append("image", image[0]);

            let request = [];
            var xhttp = new XMLHttpRequest();
            request["request"] = xhttp;

            // Set POST method and ajax file path
            xhttp.open("POST", formReq_url, true);

            let onReadyStateFunction = (function (req, obj) {

                return function () {

                    if (req.request.readyState == 4) {

                        if (req.request.status == 200) {

                            let response = JSON.parse(req.request.response);
                            obj.elementsList.setTestImageUrl(response.images[0])

                        }
                    }
                }
            });
            // call on request changes state
            xhttp.onreadystatechange = onReadyStateFunction(request, this);
            xhttp.send(formData);
        }
    }

    protected checkImageAppropriateness(imageUrl) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        document.getElementById("image-form-body").classList.add('loading');

        let subViewModel = {imageUrl: imageUrl};
        let usrReq_url: string = '/api/website-users/comments/image/check-appropriateness/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onImageCheckReturn;
        this.XHRHdl.execute();
    }

    protected onImageCheckReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                if(responseParsed.moderationResult && responseParsed.moderationResult.status){

                    obj.elementsList.setTestImageResults(responseParsed.moderationResult);
                }

            });

            document.getElementById("image-form-body").classList.remove('loading');

        }
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.elementsList.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    protected filterList(){

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/website-users/comments/get';
        this.timer = new Date().getTime();
        let subViewModel = this.elementsList.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'website-users-comments');
        this.updateViewModelFromPath(); //to set selected filters
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
                obj.loaderActive = false;
            });
        }
    }

    //
    // update the module list using the objects list
    protected updateList(responseParsed: any){

        let commentData = responseParsed.paginatedResults.data;
        if(commentData && commentData.length > 0){
            for(let comment of commentData){
                //add size query string to protect against non-images
                if(comment.imageUrl){
                    comment.imageUrl = comment.imageUrl + '?q=70&fit=contain&h=600&dpr=1';
                }
            }
        }

        this.elementsList.setComments(commentData);

        let execTime = Math.round((new Date().getTime() - this.timer)/1000*100)/100;
        this.elementsList.setResultInfo(responseParsed.paginatedResults.totalCount, responseParsed.paginatedResults.totalPage,execTime );

        // update the paginator
        this.viewModel.list.pagination.itemCount(responseParsed.paginatedResults.totalCount);
    }

    protected updateComments(ids, idStatus): void {

        let formReq_params: Array<Array<string>> = [];
        let data = {ids: ids, idStatus: idStatus};

        formReq_params.push(["data", ko.toJSON(data)] );

        let XHRHdl:XMLHttpRequestHandler = new XMLHttpRequestHandler('/api/website-users/comments/update/' , formReq_params, this);
        XHRHdl.mode                      = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction      = this.onUpdateReturn;
        XHRHdl.execute();
    }

    /**
     * Handles delete response.
     *
     * @param req
     * @param obj
     * @return {function(): void}
     */
    protected onUpdateReturn(req, obj): Function{

        return function(){

            obj.manageResponse(req, obj, function(){
                obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, 'Task updated successfully!');
                obj.getVnAppZone().showNotificationToModule();

                obj.filterList();
            });
        }
    }

    protected stripHtmlTags(str) {
        return str.replace(/<\/?[^>]+(>|$)/g, "");
    }

    // preset filter methods
    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.elementsList.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onSaveSearchPresetReturn;
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onSaveSearchPresetReturn(req, obj): Function {

        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.elementsList.addCreatedPresetToList(response);

            });

        }
    }

    protected deleteComment(idComment){
        let url = '/api/website-users/comments/delete/' + idComment;
        let params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.onReadyStateFunction = this.onDeleteReturn.bind(this);
        this.XHRHdl.execute();
    }

    protected onDeleteReturn(req, obj) {
        return function() {
            this.filterList();
        }.bind(this);
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void {

        if( "saveFavoriteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onSaveFavoriteSearchPresetReturn
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onSaveFavoriteSearchPresetReturn(req, obj): Function {

        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if( "deleteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        let usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
            });
        }
    }

    protected releaseLock(idWebsiteUser) {

        // request a lock release
        let usrReq_url: string = '/api/website-users/comments/release/' + idWebsiteUser;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.execute();
    }

    protected viewArticleOnSite(permalink, domain){

        let origin = document.location.origin;
        let brandDomain = domain;
        if(!origin.includes("https://emakicms.com")){
            brandDomain = brandDomain.replace("www.","");
        }
        let url = origin.replace("emakicms.com", brandDomain) + permalink;

        if(url.includes("mig1")){
            url = url.replace("mig1", "qa4");
        }

        if(url.includes("mig3")){
            url = url.replace("mig3", "qa3");
        }

        if(url.includes("mig4")){
            url = url.replace("mig4", "qa1");
        }
        if(url.includes("mig2")){
            url = url.replace("mig2", "qa8");
        }

        let element = document.createElement('a');
        element.setAttribute('href', url);
        element.setAttribute('target', '_blank');
        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    protected checkToxicity(){

        this.loadingIn(this.elementsList.builtTemplate);

        let formReq_url: string = '/api/website-users/comments/check-toxicity/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = this.elementsList.getViewModelForToxicityCheck();
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {
                obj.manageResponse(req, obj, function () {
                    if (req.request.status === 200) {
                        let response = JSON.parse(req.request.response);
                        if(response && response.toxicityScore){
                            obj.elementsList.setToxicityScoreResultMessage(response.toxicityScore);
                        }
                    }
                });
                obj.loadingOut(obj.elementsList.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    protected getArticlesSuggestion(keyword, idElement) {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}, idElement: idElement};
        let idBrand = this.elementsList.getTemplateViewModel().brandFilter.selectedOption();
        let usrReq_url: string = "/api/brand/" + idBrand + "/search/article/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = null;
                if(req.request.response){
                    responseParsed = JSON.parse(req.request.response);
                }

                if (req.request.status == 200) {
                    if (responseParsed && responseParsed.data.articles) {
                        obj.elementsList.setArticlesFilter(responseParsed.data.articles);
                    }
                } else if (req.request.status == "423" && responseParsed) {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                }

                // LOADING : ends
                obj.elementsList.deactivateLoading();
            }
        }
    }

    protected getUsersSuggestion(keyword, idElement) {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let idBrand = this.elementsList.getTemplateViewModel().brandFilter.selectedOption();
        let subViewModel = {list: {keyword: keyword}, idElement: idElement, idBrand: idBrand};
        let usrReq_url: string = '/api/search/website-users/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getUsersSuggestion'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getUsersSuggestion'].onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdls['getUsersSuggestion'].execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    if (responseParsed.data.users) {
                        obj.elementsList.setUserFilter(responseParsed.data.users);
                    }
                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                }

                // LOADING : ends
                obj.elementsList.deactivateLoading();
            }
        }
    }

    public viewWebsiteUser(data){

        window.open('/website-users/edit/' + data.idWebsiteUser + '/','_blank');
    }

    protected getTagsSuggestion(keyword, idElement) {
        switch (idElement) {
            case "tagFilter":
                this.getTagsSuggestionOnInput(keyword, 5, null, true, false, false);
                break;
            default:
                console.log(`getTagsSuggestion not implemented for ${idElement}`);
                break;
        }
    }

    protected getTagsSuggestionOnInput(keyword, limit, tagType, getSelectable, getNonSelectable, imageAndSpecSelectable, specFields = false) {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        let subViewModel = {filter: {keyword: keyword, limit: limit, idTagType: tagType ? tagType.id : null, getSelectable:getSelectable, getNonSelectable:getNonSelectable, imageAndSpecSelectable: imageAndSpecSelectable, specFields: specFields} };
        let usrReq_url: string = '/api/search/tag/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdl.execute();
    }

    protected onGetTagsSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data.tags) {
                    obj.elementsList.setTagFilter(responseParsed.data.tags);
                }

            });
        }
    }

    exportToCSV(data, filters) {

        if (this.exportCSVxhr) this.exportCSVxhr.abort();

        const cleanFilters = { data: { filters: ko.toJS(filters) } };

        let url: string = '/api/website-users/comments/export-csv/';

        this.exportCSVxhr = new XMLHttpRequest()
        this.exportCSVxhr.open('POST', url, true);
        this.exportCSVxhr.setRequestHeader('Content-Type', 'application/json');
        this.exportCSVxhr.responseType = 'blob';

        this.exportCSVxhr.onload = (e) => {
            if (this.exportCSVxhr.status === 200) {
                this.triggerCSVDownload(this.exportCSVxhr.response);
                this.elementsList.getTemplateViewModel().exportInProgress(false);
                this.elementsList.getTemplateViewModel().exportTextBox("Export to CSV");
                this.sendNotification("CSV export done successfully");
            }
        }


        this.exportCSVxhr.send(JSON.stringify(cleanFilters))
        this.exportCSVxhr.onerror = (e) => {
            this.elementsList.getTemplateViewModel().exportInProgress(false);
            this.elementsList.getTemplateViewModel().exportTextBox("Export to CSV");
            this.sendNotification("Error while exporting CSV", 'alert');
        };
    }

    private sendNotification(message : string = 'Export CSV', type : 'success' | 'alert' | 'error' = 'success') {
        this.getVnAppZone().notification = new vn_app_zone_notification(type, message);
        this.getVnAppZone().showNotificationToModule();
    }

    private triggerCSVDownload(response: string | Blob) {
        const blob = new Blob([response], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');

        a.href = url;
        a.download = `website_user_comments_${Date.now()}.csv`;
        document.body.appendChild(a);
        a.click();

        a.remove();
        URL.revokeObjectURL(url);
    }
}


// WEBPACK FOOTER //
// ./js/modules/website_users_comments.ts